import React from 'react';
import { ArrowForward } from '@mui/icons-material';
import { Colors } from 'library';
import { DatePicker, FieldGroup, Row, ToggleGroup } from 'library/ui';
import { CoveredShiftsCallout } from 'parent-portal/shared/CoveredShifts/CoveredShiftsCallout';
import { CoveredShift } from 'parent-portal/shared/CoveredShifts/coveredShiftsApi';
import type { DatePreset } from '../formTypes';

const PRESET_OPTIONS: { label: string; value: DatePreset }[] = [
    { label: 'Single day', value: 'singleDay' },
    { label: 'This week', value: 'thisWeek' },
    { label: 'Next 2 weeks', value: 'nextTwoWeeks' },
];

export interface CoverageDateFieldsProps {
    startDate: string;
    onStartDateChange: (value: string) => void;
    endDate: string;
    onEndDateChange: (value: string) => void;
    activePreset: DatePreset | null;
    onPresetSelect: (preset: DatePreset) => void;
    coveredShifts: CoveredShift[];
}

export function CoverageDateFields({
    startDate,
    onStartDateChange,
    endDate,
    onEndDateChange,
    activePreset,
    onPresetSelect,
    coveredShifts,
}: CoverageDateFieldsProps) {
    const today = new Date();

    return (
        <>
            <Row gap="md" align="end" wrap>
                <FieldGroup label="Start Date" required>
                    <DatePicker value={startDate} onChange={onStartDateChange} minDate={today} />
                </FieldGroup>
                <ArrowForward sx={{ fontSize: 18, color: Colors.textSecondary, marginBottom: '12px' }} />
                <FieldGroup label="End Date" required>
                    <DatePicker
                        value={endDate}
                        onChange={onEndDateChange}
                        minDate={startDate ? new Date(`${startDate}T00:00:00`) : today}
                    />
                </FieldGroup>
            </Row>
            <ToggleGroup
                options={PRESET_OPTIONS}
                value={activePreset ?? ''}
                onChange={(value) => onPresetSelect(value as DatePreset)}
            />
            <CoveredShiftsCallout coveredShifts={coveredShifts} />
        </>
    );
}
